angular.module('app-ui-profile').directive('cartUiProfile', [
  '$window',
  'translateFilter',
  'rcmApiLibMessageService',
  'profileService',
  'countryRulesRepository',
  'geoCode4Factory', // @todo use cartBasicUiCoreGeoCodeService
  function (
    $window,
    translateFilter,
    rcmApiLibMessageService,
    profileService,
    countryRulesRepository,
    geoCode4Factory
  ) {
    function link($scope) {
      $scope.profile = {};
      $scope.fieldMessages = {};
      $scope.loading = true;

      $scope.billAddressSameAllowed = false;
      $scope.billAddressSame = false;

      /* <GEO CODE BIT> */
      $scope.geoCodeState = {
        geoCodes: [],
        selectedGeoCode: null,
        haveGeoCodeOptions: false,
      };

      const handleGeoCodeStateChanged = function (geoCodeState) {
        $scope.geoCodeState = geoCodeState;
        if ($scope.geoCodeState.selectedGeoCode && $scope.geoCodeState.selectedGeoCode.geoCode) {
          $scope.profile.shipAddress.geoCode = $scope.geoCodeState.selectedGeoCode.geoCode;
          $scope.profile.shipAddress.state = $scope.geoCodeState.selectedGeoCode.state;
          $scope.profile.shipAddress.city = $scope.geoCodeState.selectedGeoCode.city;
        }
      };

      const geoCode = geoCode4Factory.createInstance(handleGeoCodeStateChanged);

      /**
       * geoCodeInit
       */
      const geoCodeInit = function () {
        if ($scope.countryRulesShipAddress.geoCodeRequired) {
          geoCode.handleChange($scope.profile.shipAddress.postalCode, {
            city: $scope.profile.shipAddress.city,
            state: $scope.profile.shipAddress.state,
            geoCode: $scope.profile.shipAddress.geoCode,
          });
        }
      };

      /**
       * geoCodeUpdate
       */
      const geoCodeUpdate = function () {
        if ($scope.countryRulesShipAddress.geoCodeRequired) {
          $scope.profile.shipAddress.geoCode = null;
          $scope.profile.shipAddress.city = null;
          $scope.profile.shipAddress.state = null;
          geoCode.handleChange($scope.profile.shipAddress.postalCode, $scope.geoCodeState.selectedGeoCode);
        }
      };

      /**
       * setFieldMessages
       *
       * @param messages
       */
      const setFieldMessages = function (messages) {
        $scope.fieldMessages = messages;
      };

      /**
       * clearMessages
       */
      const clearMessages = function () {
        $scope.fieldMessages = {};
        rcmApiLibMessageService.clearMessages('editProfile');
      };

      /**
       * addMessage
       *
       * @param message
       */
      const addMessage = function (message) {
        rcmApiLibMessageService.addMessage(message, 'editProfile');
      };

      /**
       * handleMessages
       *
       * @param messages
       */
      const handleMessages = function (messages) {
        clearMessages();
        rcmApiLibMessageService.getTypeMessages(messages, 'validatorMessage', setFieldMessages);
        rcmApiLibMessageService.getPrimaryMessage(messages, addMessage);
      };

      const buildShippingCountry = function () {
        if (!$scope.profile.shipAddress.country) {
          return $scope.profile.billAddress.country;
        }

        return $scope.profile.shipAddress.country;
      };

      /**
       * syncAddresses
       */
      const syncAddresses = function () {
        if ($scope.billAddressSame) {
          $scope.profile.billAddress = angular.copy($scope.profile.shipAddress);
        }
      };

      /**
       * canBillAddressBeSame
       *
       * @returns {boolean}
       */
      const canBillAddressBeSame = function () {
        return $scope.profile.billAddress.country == $scope.profile.shipAddress.country;
      };

      /**
       * setBillAddressSameAllowed
       */
      const setBillAddressSameAllowed = function () {
        $scope.billAddressSameAllowed = canBillAddressBeSame();
        if (!$scope.billAddressSameAllowed) {
          $scope.billAddressSame = false;
        }
      };

      /* <country-rules> */
      $scope.countryRulesShipAddress = {};
      $scope.countryRulesBillAddress = {};

      $scope.allowedShipAddressStates = {};
      $scope.allowedBillAddressStates = {};

      /**
       * onGetCountryRulesSuccess
       *
       * @param response
       */
      const onGetCountryRulesShipAddressSuccess = function (response) {
        $scope.countryRulesShipAddress = response.data;
        $scope.getAllowedStatesShipAddress(buildShippingCountry());
        geoCodeInit();
      };

      /**
       * onGetCountryRulesBillAddress
       *
       * @param response
       */
      const onGetCountryRulesBillAddress = function (response) {
        $scope.countryRulesBillAddress = response.data;
        $scope.getAllowedStatesBillAddress($scope.profile.billAddress.country);
        geoCodeInit();
      };

      /**
       * onGetCountryRulesError
       *
       * @param {*} response
       */
      const onGetCountryRulesError = function (response) {
        handleMessages(response.messages);
      };

      /**
       * getCountryRulesShipAddress
       */
      const getCountryRulesShipAddress = function () {
        countryRulesRepository.findById(
          buildShippingCountry(),
          onGetCountryRulesShipAddressSuccess,
          onGetCountryRulesError
        );
      };

      /**
       * getCountryRulesBillAddress
       */
      const getCountryRulesBillAddress = function () {
        countryRulesRepository.findById(
          $scope.profile.billAddress.country,
          onGetCountryRulesBillAddress,
          onGetCountryRulesError
        );
      };

      /**
       * onGetAllowedStatesShipAddressSuccess
       *
       * @param response
       */
      const onGetAllowedStatesShipAddressSuccess = function (response) {
        $scope.allowedShipAddressStates = response.data.allowedStates;
      };

      /**
       * onGetAllowedStatesShipAddressSuccess
       *
       * @param response
       */
      const onGetAllowedStatesBillAddressSuccess = function (response) {
        $scope.allowedBillAddressStates = response.data.allowedStates;
      };

      /**
       * onGetAllowedStatesError
       *
       * @param response
       * @param statesModel
       */
      const onGetAllowedStatesError = function (response, statesModel) {
        handleMessages(response.messages);
        $scope[statesModel] = {};
      };

      /**
       * getAllowedStates
       *
       * @param countryIso3Code
       */
      $scope.getAllowedStatesShipAddress = function (countryIso3Code) {
        // Save an API call if countyIso3 is same as current country
        if (countryIso3Code == $scope.countryRulesShipAddress.countryIso3Code) {
          onGetAllowedStatesShipAddressSuccess({ data: angular.copy($scope.countryRulesShipAddress) });
          return;
        }

        countryRulesRepository.findById(
          countryIso3Code,
          function (response) {
            onGetAllowedStatesShipAddressSuccess(response);
          },
          function (response) {
            onGetAllowedStatesError(response, 'countryRulesShipAddress');
          }
        );
      };

      /**
       * getAllowedStatesBillAddress
       *
       * @param countryIso3Code
       */
      $scope.getAllowedStatesBillAddress = function (countryIso3Code) {
        // Save an API call if countyIso3 is same as current country
        if (countryIso3Code == $scope.countryRulesBillAddress.countryIso3Code) {
          onGetAllowedStatesBillAddressSuccess({ data: angular.copy($scope.countryRulesBillAddress) });
          return;
        }

        countryRulesRepository.findById(
          countryIso3Code,
          function (response) {
            onGetAllowedStatesBillAddressSuccess(response);
          },
          function (response) {
            onGetAllowedStatesError(response, 'countryRulesBillAddress');
          }
        );
      };

      /**
       * onShipPostalCodeChange
       */
      $scope.onShipPostalCodeChange = function () {
        geoCodeUpdate();
      };

      /**
       * getCountryRulesShipAddress
       */
      $scope.onShipCountryChange = function () {
        getCountryRulesShipAddress();
      };

      /**
       * onBillCountryChange
       */
      $scope.onBillCountryChange = function () {
        getCountryRulesBillAddress();
      };

      /**
       * onSelectShipGeoCode
       */
      $scope.onSelectShipGeoCode = function () {
        handleGeoCodeStateChanged($scope.geoCodeState);
      };

      /**
       * onSubmitSuccess
       *
       * @param response
       */
      const onSubmitSuccess = function (response) {
        $scope.profile = response.data;
        getCountryRulesBillAddress();
        getCountryRulesShipAddress();
        $scope.changePassword = false;
        const successMessage = new rcmApiLibMessageService.getDefaultMessage();
        successMessage.value = translateFilter('Your information was updated successfully!');
        successMessage.code = 'success';
        successMessage.level = 'success';
        clearMessages();
        addMessage(successMessage);
      };

      /**
       * onSubmitError
       *
       * @param response
       */
      const onSubmitError = function (response) {
        handleMessages(response.messages);
      };

      /**
       * submit
       */
      $scope.submit = function () {
        if ($scope.changePassword && $scope.profile.password != $scope.profile.passwordTwo) {
          const el = document.getElementById('profilePassword2');
          if (el && el.focus) {
            el.focus();
          }
          return;
        }

        syncAddresses();
        profileService.updateProfile($scope.profile, onSubmitSuccess, onSubmitError);
      };

      /**
       * onGetProfileSuccess
       *
       * @param response
       */
      const onGetProfileSuccess = function (response) {
        $scope.profile = response.data;
        getCountryRulesBillAddress();
        getCountryRulesShipAddress();
      };

      /**
       * onGetProfileError
       *
       * @param response
       */
      const onGetProfileError = function (response) {
        handleMessages(response.messages);
      };

      /**
       * init
       */
      const init = function () {
        profileService.getProfile('current-no-cache', onGetProfileSuccess, onGetProfileError);
      };

      init();
    }

    return {
      link: link,
      scope: {},
      templateUrl: '/app_components/app-ui/src/profile/profile-directive.html',
    };
  },
]);
